(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var OVERLAY_ATTR = 'data-bodf-klaviyo-overlay';
  var HIDE_ATTR = 'data-bodf-cart-dismissed';
  var observer;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function isKlaviyoOverlay(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (!element.className || String(element.className).indexOf('kl-private-reset-css') === -1) return false;

    var style = window.getComputedStyle(element);
    if (style.position !== 'fixed') return false;

    var zIndex = parseInt(style.zIndex || '0', 10);
    if (Number.isNaN(zIndex) || zIndex < 10000) return false;

    var rect = element.getBoundingClientRect();
    return rect.width >= window.innerWidth * 0.85 && rect.height >= window.innerHeight * 0.85;
  }

  function markKlaviyoOverlays() {
    if (!isMobile()) return;

    document.querySelectorAll('.kl-private-reset-css-Xuajs1, .needsclick').forEach(function (element) {
      if (isKlaviyoOverlay(element)) {
        element.setAttribute(OVERLAY_ATTR, 'true');
      }
    });
  }

  function dismissKlaviyoOverlays() {
    document.querySelectorAll('[' + OVERLAY_ATTR + '="true"]').forEach(function (element) {
      if (element instanceof HTMLElement) {
        element.setAttribute(HIDE_ATTR, 'true');
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  }

  function isCartActionTarget(target) {
    if (!(target instanceof Element)) return false;

    return Boolean(
      target.closest('product-form-component') ||
        target.closest('add-to-cart-component') ||
        target.closest('.add-to-cart-button') ||
        target.closest('[name="add"]') ||
        target.closest('cart-drawer-component') ||
        target.closest('.cart-drawer')
    );
  }

  function handleCartIntent(event) {
    if (!isMobile()) return;

    markKlaviyoOverlays();

    if (isCartActionTarget(event.target)) {
      dismissKlaviyoOverlays();
    }
  }

  function startGuard() {
    document.addEventListener('pointerdown', handleCartIntent, true);
    document.addEventListener('submit', handleCartIntent, true);
    document.addEventListener('cart:update', dismissKlaviyoOverlays);

    markKlaviyoOverlays();
    window.addEventListener('load', markKlaviyoOverlays);

    if (!observer && document.documentElement) {
      observer = new MutationObserver(markKlaviyoOverlays);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGuard, { once: true });
  } else {
    startGuard();
  }
})();
